import { React, useState, useEffect } from "react";

const PopUpdragontigerResults = ({ resultsData, catMid, marketType }) => {
    const resultData = resultsData;

    useEffect(() => {
        console.log("Market Type:", marketType);
        console.log("Results Data:", resultsData);
    }, [resultsData, marketType]);

    const dataObj = resultsData;


    const formatMarketStartTime = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "";
        return date.toLocaleString("en-US", {
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    let Dragon = "";
    let Tiger = "";
    let Tie = "";

    let isDragonOddWinner = "";
    let isDragonEvenWinner = "";
    let isTigerOddWinner = "";
    let isTigerEvenWinner = "";
    let isDragonBlackWinner = "";
    let isDragonRedWinner = "";
    let isTigerBlackWinner = "";
    let isTigerRedWinner = "";
    let isDragonDWinner = "";
    let isDragonSWinner = "";
    let isDragonHWinner = "";
    let isDragonCWinner = "";
    let isTigerDWinner = "";
    let isTigerSWinner = "";
    let isTigerHWinner = "";
    let isTigerCWinner = "";

    if (marketType == 16) {
        if (resultData?.result == 1) {
            Dragon = "Winner";
            Tiger = "LOSER";
            Tie = "LOSER";
        } else if (resultData?.result == 2) {
            Dragon = "LOSER";
            Tiger = "Winner";
            Tie = "LOSER";
        } else if (resultData?.result == 3) {
            Dragon = "LOSER";
            Tiger = "LOSER";
            Tie = "Winner";
        }
        //hh and cc are black
        //dd and ss are red
        let Dragoncard = resultData.c1;
        let Tigercard = resultData.c2;

        if (Dragoncard) {
            const lastTwoChars = Dragoncard.slice(-2);
            const isBlack = lastTwoChars == "CC" || lastTwoChars == "HH";
            if (isBlack) {
                isDragonBlackWinner = "Winner";
                isDragonRedWinner = "LOSER";
            } else {
                isDragonBlackWinner = "LOSER";
                isDragonRedWinner = "Winner";
            }

            //console.log("Dragon card:", Dragoncard);

            const firstTwoChars = Dragoncard.slice(0, -2);
            let numberVal = firstTwoChars;
            if (firstTwoChars == "J") {
                numberVal = 11;
            } else if (firstTwoChars == "Q") {
                numberVal = 12;
            } else if (firstTwoChars == "K") {
                numberVal = 13;
            }
            if (numberVal % 2 === 0) {
                isDragonEvenWinner = "Winner";
                isDragonOddWinner = "LOSER";
            } else {
                isDragonEvenWinner = "LOSER";
                isDragonOddWinner = "Winner";
            }

            if (lastTwoChars == "HH") {
                isDragonSWinner = "Winner";
            } else if (lastTwoChars == "DD") {
                isDragonHWinner = "Winner";
            } else if (lastTwoChars == "CC") {
                isDragonCWinner = "Winner";
            } else if (lastTwoChars == "SS") {
                isDragonDWinner = "Winner";
            }
            isDragonSWinner = isDragonSWinner || "LOSER";
            isDragonHWinner = isDragonHWinner || "LOSER";
            isDragonCWinner = isDragonCWinner || "LOSER";
            isDragonDWinner = isDragonDWinner || "LOSER";
        }
        if (Tigercard) {
            const lastTwoChars = Tigercard.slice(-2);
            const isBlack = lastTwoChars == "CC" || lastTwoChars == "HH";
            if (isBlack) {
                isTigerBlackWinner = "Winner";
                isTigerRedWinner = "LOSER";
            } else {
                isTigerBlackWinner = "LOSER";
                isTigerRedWinner = "Winner";
            }

            //console.log("Dragon card:", Dragoncard);

            const firstTwoChars = Tigercard.slice(0, -2);
            let numberVal = firstTwoChars;
            if (firstTwoChars == "J") {
                numberVal = 11;
            } else if (firstTwoChars == "Q") {
                numberVal = 12;
            } else if (firstTwoChars == "K") {
                numberVal = 13;
            }
            if (numberVal % 2 === 0) {
                isTigerEvenWinner = "Winner";
                isTigerOddWinner = "LOSER";
            } else {
                isTigerEvenWinner = "LOSER";
                isTigerOddWinner = "Winner";
            }

            if (lastTwoChars == "HH") {
                isTigerSWinner = "Winner";
            } else if (lastTwoChars == "DD") {
                isTigerHWinner = "Winner";
            } else if (lastTwoChars == "CC") {
                isTigerCWinner = "Winner";
            } else if (lastTwoChars == "SS") {
                isTigerDWinner = "Winner";
            }
            isTigerSWinner = isTigerSWinner || "LOSER";
            isTigerHWinner = isTigerHWinner || "LOSER";
            isTigerCWinner = isTigerCWinner || "LOSER";
            isTigerDWinner = isTigerDWinner || "LOSER";
        }
    }

    return (
        <div>
            <div id="ResultsData">
                <div class="left-content site_family">

                    <div id="dragon-tiger" style={{ display: marketType == 16 ? "" : "none" }}  >
                        <div class="card">
                            <div class="card-header">
                                Market Start Time = {formatMarketStartTime(dataObj.evt_od)}
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div
                                        class="col-12 col-md-6"
                                        style={{ margin: "auto", textAlign: "center" }}
                                    >
                                        <div class="player-item">
                                            <b>
                                                <span class="name" style={{ color: "#000" }}>Dragon</span>
                                            </b>
                                            <div class="player-card">
                                                <div
                                                    id="BFBCardHandView"
                                                    class="BFBCardHandViewDealerab"
                                                >
                                                    <div id="BFBCardFanView" class="BFBCardFanViewab">
                                                        <div class="RSMImageView2ab">
                                                            <img
                                                                style={{
                                                                    width: "100%",
                                                                    maxWidth: "50px",
                                                                    height: "auto"
                                                                }}
                                                                src={`/assets/images/cards/${resultData.c1}.svg`}
                                                                class="img"
                                                            />
                                                            {/*<img style={{ width: "100%", maxWidth: "50px", height: "auto" }} src="/img/Cards/card_simple_27.svg" />*/}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="col-12 col-md-6"
                                        style={{ margin: "auto", textAlign: "center" }}
                                    >
                                        <div class="player-item">
                                            <b>
                                                <span class="name" style={{ color: "#000" }}>Tiger</span>
                                            </b>
                                            <div class="player-card">
                                                <div
                                                    id="BFBCardHandView"
                                                    class="BFBCardHandViewDealerab"
                                                >
                                                    <div id="BFBCardFanView" class="BFBCardFanViewab">
                                                        <div class="RSMImageView2ab">
                                                            <img
                                                                style={{
                                                                    width: "100%",
                                                                    maxWidth: "50px",
                                                                    height: "auto"
                                                                }}
                                                                src={`/assets/images/cards/${resultData.c2}.svg`}
                                                                class="img"
                                                            />
                                                            {/*<img style={{ width: "100%", maxWidth: "50px", height: "auto" }} src="/img/Cards/card_simple_32.svg" />*/}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="ExMainCardbundle"
                                    style={{ textAlign: "-webkit-center" }}
                                >
                                    <div class="market-runners">
                                        <div class="runner-runner">
                                            <h3 class="runner-name">
                                                <div class="runner-info">
                                                    <span class="clippable runner-display-name">
                                                        <h4
                                                            class="clippable-spacer"
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            data-html="true"
                                                        >
                                                            Dragon
                                                        </h4>
                                                    </span>
                                                </div>
                                            </h3>

                                            <div style={{ display: "block" }}>
                                                <div class="runner-disabled">{Dragon}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="market-runners">
                                        <div class="runner-runner">
                                            <h3 class="runner-name">
                                                <div class="runner-info">
                                                    <span class="clippable runner-display-name">
                                                        <h4
                                                            class="clippable-spacer"
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            data-html="true"
                                                        >
                                                            Tiger
                                                        </h4>
                                                    </span>
                                                </div>
                                            </h3>

                                            <div style={{ display: "block" }}>
                                                <div class="runner-disabled">{Tiger}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="market-runners">
                                        <div class="runner-runner">
                                            <h3 class="runner-name">
                                                <div class="runner-info">
                                                    <span class="clippable runner-display-name">
                                                        <h4
                                                            class="clippable-spacer"
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            data-html="true"
                                                        >
                                                            Tie
                                                        </h4>
                                                    </span>
                                                </div>
                                            </h3>

                                            <div style={{ display: "block" }}>
                                                <div class="runner-disabled">{Tie}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="market-runners">
                                        <div class="runner-runner">
                                            <h3 class="runner-name">
                                                <div class="runner-info">
                                                    <span class="clippable runner-display-name">
                                                        <h4
                                                            class="clippable-spacer"
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            data-html="true"
                                                        >
                                                            Dragon - Even
                                                        </h4>
                                                    </span>
                                                </div>
                                            </h3>

                                            <div style={{ display: "block" }}>
                                                <div class="runner-disabled">{isDragonEvenWinner}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="market-runners">
                                        <div class="runner-runner">
                                            <h3 class="runner-name">
                                                <div class="runner-info">
                                                    <span class="clippable runner-display-name">
                                                        <h4
                                                            class="clippable-spacer"
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            data-html="true"
                                                        >
                                                            Dragon - Odd
                                                        </h4>
                                                    </span>
                                                </div>
                                            </h3>

                                            <div style={{ display: "block" }}>
                                                <div class="runner-disabled">{isDragonOddWinner}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="market-runners">
                                        <div class="runner-runner">
                                            <h3 class="runner-name">
                                                <div class="runner-info">
                                                    <span class="clippable runner-display-name">
                                                        <h4
                                                            class="clippable-spacer"
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            data-html="true"
                                                        >
                                                            Tiger - Even
                                                        </h4>
                                                    </span>
                                                </div>
                                            </h3>

                                            <div style={{ display: "block" }}>
                                                <div class="runner-disabled">{isTigerEvenWinner}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="market-runners">
                                        <div class="runner-runner">
                                            <h3 class="runner-name">
                                                <div class="runner-info">
                                                    <span class="clippable runner-display-name">
                                                        <h4
                                                            class="clippable-spacer"
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            data-html="true"
                                                        >
                                                            Tiger - Odd
                                                        </h4>
                                                    </span>
                                                </div>
                                            </h3>

                                            <div style={{ display: "block" }}>
                                                <div class="runner-disabled">{isTigerOddWinner}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="market-runners">
                                        <div class="runner-runner">
                                            <h3 class="runner-name">
                                                <div class="runner-info">
                                                    <span class="clippable runner-display-name">
                                                        <h4
                                                            class="clippable-spacer"
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            data-html="true"
                                                        >
                                                            Dragon - Red
                                                        </h4>
                                                    </span>
                                                </div>
                                            </h3>

                                            <div style={{ display: "block" }}>
                                                <div class="runner-disabled">{isDragonRedWinner}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="market-runners">
                                        <div class="runner-runner">
                                            <h3 class="runner-name">
                                                <div class="runner-info">
                                                    <span class="clippable runner-display-name">
                                                        <h4
                                                            class="clippable-spacer"
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            data-html="true"
                                                        >
                                                            Dragon - Black
                                                        </h4>
                                                    </span>
                                                </div>
                                            </h3>

                                            <div style={{ display: "block" }}>
                                                <div class="runner-disabled">{isDragonBlackWinner}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="market-runners">
                                        <div class="runner-runner">
                                            <h3 class="runner-name">
                                                <div class="runner-info">
                                                    <span class="clippable runner-display-name">
                                                        <h4
                                                            class="clippable-spacer"
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            data-html="true"
                                                        >
                                                            Tiger - Red
                                                        </h4>
                                                    </span>
                                                </div>
                                            </h3>

                                            <div style={{ display: "block" }}>
                                                <div class="runner-disabled">{isTigerRedWinner}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="market-runners">
                                        <div class="runner-runner">
                                            <h3 class="runner-name">
                                                <div class="runner-info">
                                                    <span class="clippable runner-display-name">
                                                        <h4
                                                            class="clippable-spacer"
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            data-html="true"
                                                        >
                                                            Tiger - Black
                                                        </h4>
                                                    </span>
                                                </div>
                                            </h3>

                                            <div style={{ display: "block" }}>
                                                <div class="runner-disabled">{isTigerBlackWinner}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="market-runners">
                                        <div class="runner-runner">
                                            <h3 class="runner-name">
                                                <div class="runner-info">
                                                    <span class="clippable runner-display-name">
                                                        <h4
                                                            class="clippable-spacer"
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            data-html="true"
                                                        >
                                                            Dragon - Spades
                                                        </h4>
                                                    </span>
                                                </div>
                                            </h3>

                                            <div style={{ display: "block" }}>
                                                <div class="runner-disabled">{isDragonSWinner}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="market-runners">
                                        <div class="runner-runner">
                                            <h3 class="runner-name">
                                                <div class="runner-info">
                                                    <span class="clippable runner-display-name">
                                                        <h4
                                                            class="clippable-spacer"
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            data-html="true"
                                                        >
                                                            Dragon - Hearts
                                                        </h4>
                                                    </span>
                                                </div>
                                            </h3>

                                            <div style={{ display: "block" }}>
                                                <div class="runner-disabled">{isDragonHWinner}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="market-runners">
                                        <div class="runner-runner">
                                            <h3 class="runner-name">
                                                <div class="runner-info">
                                                    <span class="clippable runner-display-name">
                                                        <h4
                                                            class="clippable-spacer"
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            data-html="true"
                                                        >
                                                            Dragon - Clubs
                                                        </h4>
                                                    </span>
                                                </div>
                                            </h3>

                                            <div style={{ display: "block" }}>
                                                <div class="runner-disabled">{isDragonCWinner}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="market-runners">
                                        <div class="runner-runner">
                                            <h3 class="runner-name">
                                                <div class="runner-info">
                                                    <span class="clippable runner-display-name">
                                                        <h4
                                                            class="clippable-spacer"
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            data-html="true"
                                                        >
                                                            Dragon - Diamonds
                                                        </h4>
                                                    </span>
                                                </div>
                                            </h3>

                                            <div style={{ display: "block" }}>
                                                <div class="runner-disabled">{isDragonDWinner}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="market-runners">
                                        <div class="runner-runner">
                                            <h3 class="runner-name">
                                                <div class="runner-info">
                                                    <span class="clippable runner-display-name">
                                                        <h4
                                                            class="clippable-spacer"
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            data-html="true"
                                                        >
                                                            Tiger - Spades
                                                        </h4>
                                                    </span>
                                                </div>
                                            </h3>

                                            <div style={{ display: "block" }}>
                                                <div class="runner-disabled">{isTigerSWinner}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="market-runners">
                                        <div class="runner-runner">
                                            <h3 class="runner-name">
                                                <div class="runner-info">
                                                    <span class="clippable runner-display-name">
                                                        <h4
                                                            class="clippable-spacer"
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            data-html="true"
                                                        >
                                                            Tiger - Hearts
                                                        </h4>
                                                    </span>
                                                </div>
                                            </h3>

                                            <div style={{ display: "block" }}>
                                                <div class="runner-disabled">{isTigerHWinner}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="market-runners">
                                        <div class="runner-runner">
                                            <h3 class="runner-name">
                                                <div class="runner-info">
                                                    <span class="clippable runner-display-name">
                                                        <h4
                                                            class="clippable-spacer"
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            data-html="true"
                                                        >
                                                            Tiger - Clubs
                                                        </h4>
                                                    </span>
                                                </div>
                                            </h3>

                                            <div style={{ display: "block" }}>
                                                <div class="runner-disabled">{isTigerCWinner}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="market-runners">
                                        <div class="runner-runner">
                                            <h3 class="runner-name">
                                                <div class="runner-info">
                                                    <span class="clippable runner-display-name">
                                                        <h4
                                                            class="clippable-spacer"
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            data-html="true"
                                                        >
                                                            Tiger - Diamonds
                                                        </h4>
                                                    </span>
                                                </div>
                                            </h3>

                                            <div style={{ display: "block" }}>
                                                <div class="runner-disabled">{isTigerDWinner}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default PopUpdragontigerResults;

